import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import "./typography.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store, { initializeStoreSubscriber } from "./v2/redux/store";
import config from "./config";
import { NuqsAdapter } from "nuqs/adapters/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@radix-ui/react-tooltip";

import axios from "axios";
import { SidebarProvider } from "./v2/shared/ui/sidebar";
import { Toaster } from "./v2/shared/ui/sonner";
import { toast } from "sonner";
initializeStoreSubscriber();

axios.defaults.baseURL = config.API_URL;
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      toast.error(error.response.data.message || "Something went wrong. Please login again.");
      localStorage.removeItem("token");
      window.location.replace("/");
      queryClient.clear();
    }
    return Promise.reject(error);
  }
);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NuqsAdapter>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Provider store={store}>
            <SidebarProvider hideOnPaths={["/complete-transfer"]}>
              <App />
              <Toaster position="top-right" richColors className="capitalize" />
            </SidebarProvider>
          </Provider>
        </TooltipProvider>
      </QueryClientProvider>
    </NuqsAdapter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
